<template>
  <registration-main @back="goBack">
    <template slot="nav">
      <div class="registrationDetailNav">
        <p>{{ enrollInfo.enroll_name }}</p>
      </div>
    </template>
    <template slot="main" >
      <div class="registrationDetailMain">
        <yioks-loading v-show="showDate"></yioks-loading>
        <div v-if="!showDate" class="mainBody">
          <div class="scrollArea">
            <vue-scroll :ops="ops" ref="vs">
              <div class="mainDate">
                <div class="mainUp">
                  <div class="upLeft">
                    <div class="titleWrap">
                      <div class="title">
                        <p>报名信息</p>
                      </div>
                    </div>
                    <div class="infoWrap">
                      <p>报名时间：{{ enrollInfo.enroll_start | time(false)}} 至 {{ enrollInfo.enroll_end | time(false)}}</p>
                      <p v-if="enrollInfo.time_change_way ==='month'">
                        计划开班月份：
                        <template v-if="classPhase && classPhase.length">
                          <span @click="showClassDetail = true" style="cursor:pointer;color:#4CD964">点击查看</span>
                          <!--<span v-for="(item, index) in classPhase" :key="index" class="range-item">-->
                            <!--{{ item.start_date | time(false,false)}} 至 {{ item.end_date | time(false,false)}}-->
                          <!--</span>-->
                        </template>
                        <span v-else>{{ enrollInfo.class_start | time(false,false)}} 至 {{ enrollInfo.class_end | time(false,false)}}</span>
                      </p>
                      <p v-if="enrollInfo.time_change_way ==='periods'">
                        计划开班期数：
                        <template v-if="classPhase && classPhase.length">
                          <!--<span v-for="(item, index) in classPhase" :key="index" class="range-item">-->
                            <!--第{{index+1}}期（阶段一：{{ item.start_date | time(false, false) }}，阶段二：{{ item.end_date | time(false, false) }}）；-->
                          <!--</span>-->
                          <span @click="showClassDetail = true" style="cursor:pointer;color:#4CD964">点击查看</span>
                        </template>
                        <span v-else>{{ enrollInfo.class_start | time(false,false)}} 至 {{ enrollInfo.class_end | time(false,false)}}</span>
                      </p>
                      <p>报名类型：{{ enrollInfo.enroll_type | enrollType }}</p>
                      <p>培训等级：{{ enrollInfo.enroll_level | level }}</p>
                      <p v-if=" (userInfo.member_type=='organ' || userInfo.member_type=='orgFive') && enrollInfo.is_speediness_train">快速培训班：{{ enrollInfo.is_speediness_train ? "是" : "否" }}</p>
                      <p class="info-item" v-if="enrollInfo.enroll_type === 'continue_education' || enrollInfo.enroll_type === 'goalkeeper_education'">
                        培训方式：{{ enrollInfo.train_way | enroll_train_way }}
                      </p>
                    </div>
                  </div>
                  <div class="upRight">
                    <div class="titleWrap">
                      <div class="title">
                        <p>联系人及联系方式</p>
                      </div>
                    </div>
                      <div class="right-scroll">
                        <vue-scroll :ops="ops" ref="vs">
                          <div class="scroll">
                            <div class="infoWrap" v-if="organInfo.org_abbreviation">
                              <div class="name">
                                <div class="radius"></div>
                                <span>注册会员协会：{{organInfo.org_abbreviation}}</span>
                              </div>
                              <p>联系人：{{organInfo.user_name}}</p>
                              <p>联系方式：{{organInfo.tel_number || '--'}}</p>
                            </div>
                            
                             <div class="infoWrap" v-for="(item ,index ) in linkmenData " :key="index">
                               <div class="name">
                                 <div class="radius"></div>
                                 <span>中国足协工作人员：{{item.name}}</span>
                               </div>
                               <p>联系方式：{{item.mobile_phone}}</p>
                               <p>联系人邮箱：{{item.email}}</p>
                             </div>
                          </div>
                        </vue-scroll>
                      </div>
                  </div>
                </div>
                <div class="mainDrown">
                  <div class="titleWrap">
                    <div class="title">
                      <p>说明及附件</p>
                    </div>
                  </div>
                  <div class="downleft">
<!--                    <vue-scroll :ops="ops">-->
<!--                    </vue-scroll>-->
                      <div class="infoWrap">
                      <div class="detail">
                        <template v-if="enrollInfo.enroll_content">
                          <p  class="intro">说明：</p>
                          <p v-html="enrollInfo.enroll_content" class="mainIntro"></p>
                        </template >
                        <template v-else>
                          <p >说明：--</p>
                        </template>
                      </div>
                      <div class="documentDate">
                        <p v-show="documentDate.length>0">附件：</p>
                        <div>
                          <p v-for="(item ,index) in documentDate"
                             :key="index"
                             @click="downloadFile(item.document_address)"
                          >{{index + 1 }}. {{item.document_title}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="btns" v-if="showAdd">
                      <template v-if="showEnter">
                        <el-button type="primary" @click="commit(true)">点击完善报名信息</el-button>
                      </template>
                      <template v-else>
                        <el-button type="primary" class="notCommit">名额已满</el-button>
                      </template>

                    </div>
                    <div class="btns" v-if="showEdit">
                      <template v-if="showEnter">
                        <el-button type="primary" @click="commit(false)">点击编辑报名信息</el-button>
                      </template>
                      <template v-else>
                        <el-button type="primary" class="notCommit">名额已满</el-button>
                      </template>
                    </div>
                    <div class="btns" v-if="showView">
                      <el-button type="primary" @click="lookSignUp(enrollPersonnel.uid)">
                        <p class="up">报名成功</p>
                        <p class="down">点击查看详情</p>
                      </el-button>
                    </div>
                    <div class="btns" v-if="showThrough">
                      <el-button type="primary" @click="viewResult">
                        <p class="up">报名成功</p>
                        <p class="down">点击查看详情</p>
                      </el-button>
                    </div>
                    <div class="btns" v-if="noEdit">
                      <el-button type="primary" class="notCommit">
                        报名申请已被拒绝
                        <!--<p class="down">点击查看详情</p>-->
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <el-dialog
          class="detail-info-dia"
          title="详细信息"
          :visible.sync="ifDiaShow"
          :close-on-click-modal="false"
          width="750px"
          top="12vh"
        >
          <div class="scroll-wrap">
            <vue-scroll :ops="disScrollOpt" ref="vScroll">
              <div class="stu-info-box">
                <stu-detail-info :info='curStuInfo'></stu-detail-info>
              </div>
            </vue-scroll>
          </div>
        </el-dialog>
        <el-dialog width="350px"
          :visible.sync="verifyResult"
          custom-class="verify_result_dialog"
          :close-on-click-modal="false">
          <div class="verifyResult">
            <template v-if="verifyMsg.status==='审核中'">
              <p>
                <span>报名材料已经提交成功，请耐心等待审核，审核结果将通过短信方式通知</span>
              </p>
            </template>
            <template v-else-if="verifyMsg.status==='通过'">
              <p>
                <span>报名成功，信息审核通过，具体录取情况请等待中国足协官方网站或短信通知。</span>
              </p>
            </template>
            <template v-else>
              <p>录取状态：{{ verifyMsg.status }}</p>
              <p v-if="verifyMsg.opinion">
                <span>审核理由：</span>
                <span>{{ verifyMsg.opinion || "--" }}</span>
              </p>
            </template>
          </div>
        </el-dialog>

        <el-dialog
          title="提示"
          :visible.sync="isShowCompleteSelfInfo"
          width="450px"
          :close-on-click-modal="false"
          custom-class="self-tips-complete"
          :top="'20vh'"
          >
          <div class="tips-for-complete">
            <div class="little-tips">
              请您更新简历，提供当前的工作信息和证明。个人简历不完整，将会影响培训报名录取结果。如您的简历已经更新完成，请直接报名。
            </div>
            <div class="btns">
              <el-button type="primary" @click="handleCompleteSelfInfo">点击完善简历信息</el-button>
              <el-button type="primary" @click="handleGoForSign">简历已更新，进入报名</el-button>
            </div>

          </div>
        </el-dialog>
        <class-info-detail
          v-if="showClassDetail"
          :isShow.sync="showClassDetail"
          :time_change_way="enrollInfo.time_change_way"
          :dataPhase="classPhase"
        ></class-info-detail>
      </div>
    </template>
  </registration-main>
</template>

<script>
import commonFun from "@/assets/js/yioks";
import { enroll_type,statusKV ,statusKVStudent,LevelFilters,enroll_train_way} from "@/assets/js/status";
const { downfile } = commonFun;
import ops from "@/assets/js/vuescrollOption";
import { signUpDetail } from "@/api/system_manager/api";
import { personnel_admission_status,info_view } from "@/api/ab_signup/api";
import identify1 from "@/assets/images/vita/identify1.png";
import identify2 from "@/assets/images/vita/identify2.png";
import avatorImg from "@/assets/images/person.png";
 import {storageData} from "@/assets/js/storage";
const HOSTURL = process.env.VUE_APP_URL;

export default {
  name: "RegistrationInfo",
  data() {
      const userInfo = storageData.getUserInfo();
    return {
      ops: ops(),
      can_sign_msg:'',
      statusKV,
      statusKVStudent,
      userInfo,
      disScrollOpt: ops(true),
      uuid: this.$route.query.uuid,
      documentDate: [],
      linkmenData: [],
      enrollInfo: {},
      organInfo: {},
      classPhase: [],
      ifDiaShow: false,
      verifyResult:false,
      showClassDetail:false,
      verifyMsg:{},
      enrollPersonnel: {},
      personnelNum: 0,
      enroll_person_num: 0,
      showDate:true,
      showAdd:false,
      showEdit:false,
      showThrough:false,
      showView:false,
      showEnter:false,
      noEdit:false,
      curStuInfo: {
        studentSingnInfo: {},
        enrollMap: {},
        report_list:[],
        language_list: [],
        academic_data: [],
        coach_data: [],
        experience_data: [],
        experience_data_not: [],
        playing_data: []
      },
      isShowCompleteSelfInfo: false,
    };
  },
  components: {
    "registration-main": () => import("@/components/LayOut/Common/up-down"),
    "v-icon": () => import("vue-awesome/components/Icon"),
     "yioks-loading": () => import("@/components/Loading/Loading"),
    "stu-detail-info": () => import("@/components/EnrollPersonnelInfo/EnrollPersonnelInfo"),
    "class-info-detail": () => import("@/components/ClassInfoBox/EnrollClassPhaseDetail"),
  },
  created() {
    this.getSignUp();
    if(['registration','expireStudent','teacher','teaFive','expFive','student'].includes(this.userInfo.member_type)){
      this.getPersonnelStatus();
    }
  },
  methods: {
    downloadFile(url) {
      downfile(url);
    },
    goBack() {
        if(this.userInfo.member_type === "expireStudent"||this.userInfo.member_type === "student"){
//          if (this.enrollInfo.enroll_type === "continue_education") {
//            this.$router.push({path:'continueList'})
//          } else {
//            this.$router.push({path:'registrationList'})
//          }
          this.$router.go(-1)
        }else if(this.userInfo.member_type === "teacher"){
          this.$router.push({path:'registrationList'})
        }else{
          this.$router.go(-1)
        }

    },
    commit(flag) {
      const errorTipsList = [ 'make_up_exam', 'common', 'continue_education', 'teacher_train', 'goalkeeper_education','physical_train','goalkeeper_train','physical_make_up_exam']
        // if (this.enrollInfo.enroll_type==='make_up_exam' && !this.is_can_sign ){
        //     this.$message.error(this.can_sign_msg)
        // } else if (this.enrollInfo.enroll_type==='common' && !this.is_can_sign){
        //     this.$message.error(this.can_sign_msg)
        // } else if (this.enrollInfo.enroll_type==='continue_education' && !this.is_can_sign){
        //   this.$message.error(this.can_sign_msg)
        // } else if (this.enrollInfo.enroll_type==='teacher_train' && !this.is_can_sign){
        //   this.$message.error(this.can_sign_msg)
        // } else if (this.enrollInfo.enroll_type === 'goalkeeper_education' && !this.is_can_sign) {
        //   this.$message.error(this.can_sign_msg)
        // }else {
        //     this.$router.push({path: 'register_file', query: {signId: this.uuid}});
        // }

        if (errorTipsList.includes(this.enrollInfo.enroll_type) && !this.is_can_sign ){
            this.$message.error(this.can_sign_msg)
        }else {
          // is_can_sign
          if(flag) {
            // 继续教育 不需要再完善简历了 直接进入报名
            if([  'continue_education',  'goalkeeper_education'].includes(this.enrollInfo.enroll_type)){
              this.$router.push({path: 'register_file', query: {signId: this.uuid}});
            }else{
              this.isShowCompleteSelfInfo = true;
            }
            
          } else {
              this.$router.push({path: 'register_file', query: {signId: this.uuid}});
          }
            // else {
            //   this.$router.push({path: 'register_file', query: {signId: this.uuid}});
            // }
        }
    },
    getSignUp(){
      this.showDate=true;
      signUpDetail({ enroll_uuid: this.uuid })
      .then(res => {
        if (Number(res.data.status) === 0) {
          this.showDate=false;
          const { enrollInfo,linkmenData,documentDate,personnelNum,enroll_person_num,is_can_sign,can_sign_msg, classPhase,organInfo } = res.data.result;
          this.classPhase = classPhase;
          this.enrollInfo = enrollInfo;
          this.linkmenData = linkmenData;
          this.documentDate = documentDate;
          this.personnelNum = personnelNum;
          this.enroll_person_num = enroll_person_num;
          this.is_can_sign=is_can_sign;
          this.can_sign_msg=can_sign_msg;
          if(organInfo){
            this.organInfo=organInfo
          }
          // 判断名额是否足够
          if(this.enrollInfo.enroll_person_num >0){
            this.showEnter = this.personnelNum < this.enrollInfo.enroll_person_num ? true : false;
          }else{
            this.showEnter = true;
          }
        }
      })
      .catch(err => {
        console.error(err);
        this.showDate=true;
      });
    },
    getPersonnelStatus(){
      personnel_admission_status({ enroll_uuid: this.uuid })
      .then(res => {
        if (Number(res.data.status) === 0) {
          const { enrollPersonnel,enrollPersonnelAudit } = res.data.result;
          this.enrollPersonnel = enrollPersonnel;
          if(this.enrollPersonnel.personnel_id === null){
            this.showAdd = true;
          }else if(this.enrollPersonnel.matriculate_status === 'personnelEdit' || this.enrollPersonnel.matriculate_status === 'personnelPerfect' ){ // 可以编辑的状态
            this.showEdit = true;
          }
//          else if(this.enrollPersonnel.matriculate_status === 'examThrough' || this.enrollPersonnel.matriculate_status === 'enrollCheckThrough' || this.enrollPersonnel.matriculate_status === 'teacherThrough'){ // 通过的状态
//            this.showThrough = true;
//            if ((this.enrollInfo.enroll_level==='P' || this.enrollInfo.enroll_level ==='PRO' || this.enrollInfo.enroll_level==='0') && enrollPersonnel.matriculate_status==='examThrough' ){
//                this.verifyMsg={"status":'已录取',"opinion":Object.keys(enrollPersonnelAudit).length > 0 ? enrollPersonnelAudit.opinion:null};
//            }else{
//                this.verifyMsg={"status":statusKVStudent[enrollPersonnel.matriculate_status].text,"opinion":Object.keys(enrollPersonnelAudit).length > 0 ? enrollPersonnelAudit.opinion:null};
//            }
//          }
          else if(this.enrollPersonnel.matriculate_status === 'enrollCheckRefused' || this.enrollPersonnel.matriculate_status === 'personnelRefused' || this.enrollPersonnel.matriculate_status === 'examRefused' || this.enrollPersonnel.matriculate_status === 'teacherRefused'){ // 拒绝 不能修改
            this.noEdit = true;
            this.verifyMsg={"status":statusKVStudent[enrollPersonnel.matriculate_status].text,"opinion":Object.keys(enrollPersonnelAudit).length > 0 ? enrollPersonnelAudit.opinion:null};
          }else{ //提交中 查看报名详情
            this.showView = true;
          }
        }
      })
      .catch(err => {
        console.error(err);
      });
    },
    lookSignUp(uid) {
      this.getPersonnelInfo(uid);
      this.ifDiaShow = true;
    },
    getPersonnelInfo(uid) {
      info_view({ uuid: uid,enroll_uuid:this.uuid }).then(({ data }) => {
        if (data.status === 0) {
          const { result } = data;
          this.curStuInfo.studentSingnInfo = {
            ...result.studentSingnInfo,
            id_card_photo_front: result.studentSingnInfo.id_card_photo_front
              ? HOSTURL + result.studentSingnInfo.id_card_photo_front
              : identify1,
            id_card_photo_verso: result.studentSingnInfo.id_card_photo_verso
              ? HOSTURL + result.studentSingnInfo.id_card_photo_verso
              : identify2,
            profile_picture: result.studentSingnInfo.profile_picture
              ? HOSTURL + result.studentSingnInfo.profile_picture
              : avatorImg
          };
          for (const key in this.studentSingnInfo) {
            if (this.studentSingnInfo.hasOwnProperty(key)) {
              const element = this.studentSingnInfo[key];
              this.studentSingnInfo[key] = element || "--";
            }
          }

          this.curStuInfo.language_list = [...result.language_list];
          this.curStuInfo.academic_data = [...result.academic_data];
          this.curStuInfo.coach_data = [...result.coach_data];
          this.curStuInfo.experience_data = [...result.experience_data];
          this.curStuInfo.experience_data_not = [...result.experience_data_not];
          this.curStuInfo.playing_data = [...result.playing_data];
          this.curStuInfo.enrollMap = {...result.enrollMap};
          this.curStuInfo.report_list = [...result.report_list];
          if (this.curStuInfo.studentSingnInfo.student_information === 'Active' && !this.curStuInfo.studentSingnInfo.total_score && result.experience_data_backup.length > 0 ){
            this.curStuInfo.experience_data = [...result.experience_data_backup];
          }
          // let take_place = '';
          // if(this.curStuInfo.studentSingnInfo.take_place && this.curStuInfo.studentSingnInfo.take_place !== '无'){
          //   const temList = JSON.parse(this.curStuInfo.studentSingnInfo.take_place)
          //   temList.forEach(letTmp =>{
          //     if(letTmp){
          //       let tmp1 = letTmp[0];
          //       for(var x = 1;x<letTmp.length ; x++){
          //         if(letTmp[x]){
          //           tmp1 = tmp1 + '/' + letTmp[x] ;
          //         }
          //       }
          //       take_place = take_place + tmp1 + '，';
          //     }
          //   })
          //   take_place = take_place.substr(0, take_place.length - 1);
          //   this.curStuInfo.studentSingnInfo.take_place=take_place
          // }
  
          // let sport_experience = '';
          // if(this.curStuInfo.studentSingnInfo.sport_experience && this.curStuInfo.studentSingnInfo.sport_experience !== '无'){
          //   const temList = JSON.parse(this.curStuInfo.studentSingnInfo.sport_experience)
          //   temList.forEach(letTmp =>{
          //     if(letTmp){
          //       let tmp1 = letTmp[0];
          //       for(var x = 1;x<letTmp.length ; x++){
          //         if(letTmp[x]){
          //           tmp1 = tmp1 + '/' + letTmp[x] ;
          //         }
          //       }
          //       sport_experience = sport_experience + tmp1 + '，';
          //     }
          //   })
          //   sport_experience = sport_experience.substr(0, sport_experience.length - 1);
          //   this.curStuInfo.studentSingnInfo.sport_experience=sport_experience
          // }
  
          // let coach_experience = '';
          // if(this.curStuInfo.studentSingnInfo.coach_experience && this.curStuInfo.studentSingnInfo.coach_experience !== '无'){
          //   const temList = JSON.parse(this.curStuInfo.studentSingnInfo.coach_experience)
          //   temList.forEach(letTmp =>{
          //     if(letTmp){
          //       let tmp1 = letTmp[0];
          //       for(var x = 1;x<letTmp.length ; x++){
          //         if(letTmp[x]){
          //           tmp1 = tmp1 + '/' + letTmp[x] ;
          //         }
          //       }
          //       coach_experience = coach_experience + tmp1+ '，';
          //     }
          //   })
          //   coach_experience = coach_experience.substr(0, coach_experience.length - 1);
          //   this.curStuInfo.studentSingnInfo.coach_experience=coach_experience
          // }
        } else {
        }
      });
    },
    viewResult(){
      this.verifyResult = true;
    },

    // 前往完善个人简历
    handleCompleteSelfInfo() {
       this.$router.push({path: 'qualificationSetting',
        query: {
          backUrl: JSON.stringify(this.$route.fullpath)
        }
       });
    },

    handleGoForSign() {
       this.$router.push({path: 'register_file', query: {signId: this.uuid}});
    }

  },
  filters:{
    enrollType(type){
      return enroll_type(type)
    },
    enroll_train_way(type){
      return enroll_train_way(type)
    },
      level(level){
          return LevelFilters(level)
      }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';
@import '~@/assets/css/mixin';

.registrationDetailNav, .registrationDetailMain {
  flex: 1 1 auto;
  height: 100%;
}

.registrationDetailNav {
  display: flex;
  align-items: center;
  font-size: $font_size_big;
}

.btns {
  display: flex;
  align-items: flex-end;
  margin: 13px 20px 12px;
  .notCommit{
    background-color : $color_background_grey;
    border-color: $color_background_grey;
    cursor:no-drop;
  }

  .btn {
    width: 105px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: $font_size_medium;
    background-color: $color_suc;
    cursor: pointer;
    user-select: none;
  }
}

.registrationDetailMain {
  width: 100%;
  background-color: $block_bg_color_base;

  .mainBody {
    .scrollArea {
      width: 100%;
      height: 600px;
      padding: 15px 0 0;

      .mainDate {
        padding: 20px 50px 0px 50px;
        font-size: $font_size_big;

        .titleWrap {
          margin: 0 0 20px 0;
          display: flex;
          justify-content: space-between;
          font-size: 20px;
          user-select: none;

          .title {
            display: flex;
            align-items: flex-end;


            p {
              line-height: 20px;

              span {
                margin: 0 0 0 10px;
                font-size: $font_size_medium;
              }
            }
          }

          .moreBtn {
            cursor: pointer;
          }
        }

        .mainUp {
          display: flex;
          width: 100%;
          justify-content: space-between;

          .upLeft {
            width: 105%;

            .titleWrap {
              width: 100%;
              padding-bottom: 10px;
              border-bottom: 2px solid white;

              p {
                color: #4cd964;
              }
            }

            .infoWrap {
              p {
                padding-left: 10px;
                margin-bottom: 20px;
              }
            }
          }

          .upRight {
            padding-left: 40px;
            height: 250px;
            width: 100%;

            .titleWrap {
              width: 100%;
              padding-bottom: 10px;
              border-bottom: 2px solid white;

              p {
                color: #4cd964;
              }
            }
            .right-scroll{
              width 360px
              height 200px
              overflow hidden
              .scroll {
                width 100%
                height 200px
                .infoWrap {
                  margin-bottom: 20px;
                  .name {
                    margin-bottom: 10px;
                  }
                }
              }
              .radius {
                display: inline-block;
                height: 10px;
                width: 10px;
                background-color: #4cd964;
                border-radius: 50%;
                margin-right: 10px;
              }

              span {
                padding-bottom: 10px;
              }

              p {
                margin-bottom: 10px;
                padding-left: 20px;
              }
            }
          }
        }

        .mainDrown {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          height: 45%;
          margin-top: 25px;
          position :relative;
          .titleWrap {
            flex-basis: 100%;
            padding-bottom: 10px;
            border-bottom: 2px solid white;
            .title {
              p {
                color: #4cd964;
              }
            }
          }
          .downleft{
            display :flex;
            width :500px;
            .btns{
              position: absolute;
              right: 40px;
              top: 100px;
              .up{
              margin-top -5px
              }
              .down{
                position: relative;
                top: 5px
              }
            }
          }
          .infoWrap {
            flex-basis :50%;
            .detail{
              display flex
              justify-content left
              p{
                width :500px;
                word-wrap: break-word;
                word-break: break-all;
                  a{
                    color #4cd964
                  }
              }
              .intro{
                  width 70px
              }
              .mainIntro{
                padding 0
                width 410px
              }
            }
            .documentDate {
              div {
                margin-top: -40px;
                padding-left: 50px;
                p {
                  cursor: pointer;
                  color: #4cd964;
                  width: 435px;
                  word-wrap: break-word;
                  word-break: break-all;
                }
              }
            }

            div {
              margin-bottom: 0;

              p {
                padding-left: 15px;
                margin-bottom: 15px;
              }
            }
          }
        }
      }
    }
  }
  .detail-info-dia{
    .scroll-wrap{
      display block
      height 630px
      overflow hidden
      position relative
      .stu-info-box{
        display block
        padding 0 15px
        font-size $font_size_medium
      }
    }
  }
}
.range-item {
  margin-right 10px
  &:not(:last-child)::after {
    content: ''
  }
}

.tips-for-complete
  .little-tips
    height 80px
    display flex
    justify-content: center
    align-items: center
    margin-bottom: 20px
    font-size: 16px
    text-align: center
    line-height 2em
    padding 0 15px
  .btns
    display flex
    align-items center
    justify-content: space-around
</style>
